var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "d-flex justify-content-center",
        staticStyle: { "padding-top": "200px" },
      },
      [
        !_vm.errorMessage
          ? _c("div", { staticClass: "card" }, [_vm._m(0)])
          : _vm._e(),
        _vm._v(" "),
        _vm.errorMessage
          ? _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("h5", { staticClass: "card-title" }, [
                  _vm._v("Access denied"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "card-text lead" }, [
                  _vm._v(_vm._s(_vm.errorMessage)),
                ]),
                _c("br"),
              ]),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "card-body" }, [
      _c("h5", { staticClass: "card-title" }, [
        _c("i", { staticClass: "fa fa-spinner fa-spin" }),
        _vm._v(" Loading..."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }